<template>
    <div class="spinner-container" :class="{'spinner-container--fullscreen': fullscreen}">
        <div class="circle-path"></div>
        <h1 class="message">{{ message }}</h1>
    </div>
</template>

<script>
export default {
    props: {
        fullscreen: {
            type: Boolean,
            required: false,
            default: false,
        },
        message: {
            type: String,
            default: "",
        },
    },
};
</script>

<style scoped>
.spinner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: progress;
}

.spinner-container--fullscreen {
    position: fixed;
    background: rgba(255,255,255,1.0);
    background: linear-gradient(270deg, rgba(255,255,255,0.4), rgba(255,255,255,1.0));
    background-size: 400% 400%;
    z-index: 3000;
    top: 0;
    left: 0;

    -webkit-animation: LoadingAnimation 8s ease infinite;
    -moz-animation: LoadingAnimation 8s ease infinite;
    animation: LoadingAnimation 8s ease infinite;

    @-webkit-keyframes LoadingAnimation {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }
    @-moz-keyframes LoadingAnimation {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }
    @keyframes LoadingAnimation {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }
}

.circle-path {
    height: 48px;
    width: 48px;
    color: rgba(90, 90, 90, 0.2);
    position: relative;
    display: inline-block;
    border: 5px solid;
    border-radius: 50%;
    border-right-color: #0293d6;
    animation: rotate 1s linear infinite;
}

@keyframes rotate {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}

.message {
    position: absolute;
    transform: translateY(70px);
    width: 80%;
    top: 50%;
    text-align: center;
}
</style>